import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { GameProvider } from "../../context/GameContext";
import StartGameVillages from '../../components/StartGameVillages/StartGameVillages';
import StartIndependantGame from '../../components/StartIndependantGame/StartIndependantGame';
import styles from './StartGamePage.module.scss';

const StartGamePage = () => {
    const [searchParams] = useSearchParams();
    const villageId = searchParams.get('village');
    const parcoursId = searchParams.get('parcours');
    const gameId = searchParams.get('jeu');

    if (villageId && parcoursId) {
        return (
            <GameProvider>
                <div className={styles.container}>
                    <StartGameVillages villageId={villageId} parcoursId={parcoursId} />
                </div>
            </GameProvider>
        );
    } else if (gameId) {
        return (
            <GameProvider>
                <div className={styles.container}>
                    <StartIndependantGame gameId={gameId} />
                </div>
            </GameProvider>
        );
    } else {
        return (
            <div className={styles.container}>
                <p>Erreur : paramètres invalides. Veuillez vérifier votre lien.</p>
            </div>
        );
    }
};

export default StartGamePage;
